import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../../../../utils";
import { TtOrderEvent, TtOrderMetadata, TtOrderSnapshot } from "../types";

export interface OrderDetailResponse {
  snapshot: TtOrderSnapshot | null;
  events: TtOrderEvent[];
  metadata: TtOrderMetadata | null;
}

export const ORDER_DETAIL_QUERY_KEY_PREFIX = ["risk", "brokerage", "tt", "v2", "detail"] as const;

export function orderDetailQueryKey(guidOrderId: string) {
  return [...ORDER_DETAIL_QUERY_KEY_PREFIX, guidOrderId] as const;
}

export function useGetOrderDetail(guidOrderId: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: orderDetailQueryKey(guidOrderId),
    queryFn: () => fetchApiGet<OrderDetailResponse>(
      `/brokerage/tt/v2/orders/${encodeURIComponent(guidOrderId)}/detail`
    ),
    enabled: (options?.enabled ?? true) && !!guidOrderId,
  });
}
